import {Component, OnInit} from '@angular/core';
import {
  CtBinaryOperator,
  CtExportConfiguration,
  CtModelConfiguration,
  CTModelDatatableFilter,
  CtModelOperator,
  MAT_RAISED_PRIMARY,
} from "@ctsolution/ct-framework";
import {CTMGeneralService} from "../../../_core/lib/general.service";
import {ActivatedRoute} from "@angular/router";
import {CompanyRouteData} from "../../../_core/route-data/company.route-data";
import {DEFAULT_DATATABLE_CONFIGURATION} from "../../../_core/constants";
import {CompanyService} from "../company.service";
import {CustomerType} from "../../../_core/enum/customer-type";
import {CtManagerService} from "../../../_core/lib/ct-manager.service";
import {CTConfigurationModel} from "../../../_core/classes/ct-configuration-model";

@Component({
  selector: 'app-company-list',
  template: `
    <ct-model *ngIf="configuration" [configuration]="configuration"></ct-model>`,
})
export class CompanyListComponent implements OnInit {

  configuration: CtModelConfiguration<CompanyListComponent> | null = null;

  // Configurazione per controllare la visibilità dell'export
  companyExportConfiguration: CTConfigurationModel = CTConfigurationModel.create().setVisible(false);

  constructor(
    private general: CTMGeneralService,
    private route: ActivatedRoute,
    private companyService: CompanyService,
    private managerService: CtManagerService) {
  }

  async ngOnInit() {

    // ✅ Recupera la configurazione override per company export
    await this.managerService.getComponentOverride("company", "companyExportConfiguration", this.companyExportConfiguration).then((component) => {
      return;
    });

    const configuration = CtModelConfiguration
      .create<CompanyListComponent>()
      .setRouteData(CompanyRouteData())
      .setCTDatatableConfiguration(DEFAULT_DATATABLE_CONFIGURATION())
      .setOperations([
        CtModelOperator.Create,
        CtModelOperator.FilterCustomToggle,
        ...(this.companyExportConfiguration.visible ? [CtModelOperator.Export] : [])  // ✅ Abilita export solo se visible
      ])
      .setCustomToggleLabel('Nascondi disabilitati')
      .setCustomToggleInitialState(true)
      .setCustomTogglePersistState(true)
      .setOnCustomToggle((active: boolean) => {
        
        if (active) {
          
          configuration.filterValues.upsertConstantFilter(
            CTModelDatatableFilter.create()
              .setField('Active') // Campo da filtrare
              .setValue(true)   // Valore del filtro
              .setOperatorType(CtBinaryOperator.Equal) // Operatore
          );
          
        } else {
          
          configuration.filterValues.removeConstantByField('Active');
        
        }
        
      })

    const typePathValue: string | null = this.route.snapshot.paramMap.get("type");

    if (!typePathValue) return;

    const isSupplier = this.companyService.getCustomerTypeByRouteValue(typePathValue) === CustomerType.Supplier;

    configuration
      .filterValues
      .addConstantFilter(
        CTModelDatatableFilter
          .create()
          .setField(isSupplier ? 'IsSupplier' : 'IsCustomer')
          .setValue(true)
          .setOperatorType(CtBinaryOperator.Equal)
      )

    if (isSupplier) {

      this
        .route
        .data
        .subscribe(data => {
          data["title"] = "CT_MENU.supplier";
        });

    }

    // ✅ Configurazione Export SOLO se companyExportConfiguration.visible è true
    // Differenzia tra Supplier e Customer
    if (this.companyExportConfiguration.visible) {
      configuration
        .setExportConfiguration(
          CtExportConfiguration
            .create()
            // Action backend: diversa per Supplier e Customer
            .setAction(isSupplier ? 'ExportExcel_Company_Private' : 'ExportExcel_Company_Business')
            // Label bottone
            .setLabel('Esporta')
            // Icona bottone
            .setIcon('download')
            // Nome file per il download (senza estensione)
            .setFileName(isSupplier ? 'Export_Clienti' : 'Export_Clienti')
            // Colore bottone blu
            .setMaterialOptions(MAT_RAISED_PRIMARY)
            // Esporta tutti i record ignorando la paginazione
            .setIncludePagination(false)
        );
    }

    configuration
      .setOnCreate(() => this.general.navigateOnCTModelRouter(["customer", typePathValue], "create", {qpHandling: 'preserve'}))
      .setOnEdit(event => this.general.navigateOnCTModelRouter(["customer", typePathValue], "edit", {
        value: event,
        configuration: this.configuration!,
        qpHandling: 'preserve'

      }));

    this.configuration = configuration;

  }

}
